import React, { useState, useContext, useRef, useEffect, useLayoutEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Delete from "../../Icons/Delete";
import styles2 from "../css/COLUMN.module.css";
import { Button, Form, Col } from "react-bootstrap";
import SvgGroupVerticalIcon from "../../Icons/GroupVerticalIcon";
import "./ElemDeleteControl.css";
import styles from "../css/ROW.module.css";
import { AppContext } from "../../Resources/CanvasContextFile";
import CustomizedAlert from "../../ReusableComponents/Alert/CustomizedAlert";
import { downloadJson } from "../../Resources/globalFunctions";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import ActiveIcon from "../../ReusableComponents/ActiveIcon/ActiveIcon";
import SvgStyle1 from "../../Icons/SectionIcons/style1";
import SvgStyle2 from "../../Icons/SectionIcons/style2";
import SvgStyle3 from "../../Icons/SectionIcons/style3";
import SvgStyle4 from "../../Icons/SectionIcons/style4";
import {ReactComponent as TabColumn1} from "../../Icons/TabColumn1.svg";
import {ReactComponent as TabColumn2} from "../../Icons/TabColumn2.svg";
import {ReactComponent as TabColumn3} from "../../Icons/TabColumn3.svg";
import {ReactComponent as TabColumn4} from "../../Icons/TabColumn4.svg";
import {ReactComponent as TabColumn5} from "../../Icons/TabColumn5.svg";
import {ReactComponent as TabColumn6} from "../../Icons/TabColumn6.svg";
import { ReactComponent as Upload } from "../../Icons/Upload_White 10x10.svg";
import {
  createSmartFormState,
  sendRequestForControl,
  createUniqueId,
  updateRowNColumn,
  getColumnLayout,
  fetchGridStates,
  getStepIndex,
  getSubStepIndex,
  getSubChildMenuIndex,
  getDevice
} from "../../components/IFormDesignerLayout/IFormDesignerLogic";
import axios from "../../axios";
import { ThemeJSON } from "../../components/IFormDesignerLayout/Theme/ThemeJSON";
import { generateJsonToSend } from "../../components/IFormDesignerLayout/RequestLogic";
import { quickControlMapping } from "./ElemDeleteControlMapping";
import { useDispatch, addContexts, useSelector } from "../../Redux";
import { red } from "@material-ui/core/colors";

import ImportSection from "./ImportSection";
import { setWeekWithOptions } from "date-fns/fp";
import SaveTemplate from "./SaveTemplate";
import html2canvas from "html2canvas";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import { checkValid, isObjectEmpty } from "../../Resources/globalFunctions";
import { recursiveJsonReader1 } from "../../components/IFormDesignerLayout/ApplicationAPI/applicationApi";
import cloneDeep from "lodash-es/cloneDeep";
import { formStateStore } from "../../Redux/Store/store";
import { updateContexts, updateFormStateContextWithoutRender, updateGridContexts } from "../../Redux/Actions/FormStateActions";
import { GetState, GetStateFromData } from "../../components/CustomHooks/CustomHooks";
import { findFrameColumnLayout } from "../../components/IFormDesignerLayout/SectionLayoutLogic";

const useStyles = makeStyles({
  main: {
    //position: "relative",
  },
  icons: {
    height: "10px",
    marginTop: "4px",
    marginBottom: "4px",
    width: "10px",
    display: "inline !important",
    marginRight: "10px",

    "& path": {
      fill: "#fff",
      stroke: "#fff"
    }
  },
  moreIcon: {
    height: "10px",
    width: "4px",
    marginRight: "9px"
  },
  uploadJson: {
    marginLeft: "-1px !important",
    top: "-4px !important"
    // backgroundColor:"red"
  },
  optionsPopUp: {
    position: "absolute",
    width: "129px",
    // height: "55px",
    minHeight:"55px",
    height:'auto',
    left: "110px",
    background: "#ffffff",
    boxShadow: "0px 0px 6px #00000029",
    borderRadius: "2px",
    font: "normal normal normal 12px/17px Open Sans",
    letterSpacing: "0px",
    color: "#6B6B6B",
    textAlign: "left",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "10px",
    transform: "translate(0px,5px)"
    // zIndex: "99999",
  },
  optionsPopUpTile:{
    position: "absolute",
    left: "110px",
    background: "#ffffff",
    boxShadow: "0px 0px 6px #00000029",
    borderRadius: "2px",
    font: "normal normal normal 12px/17px Open Sans",
    letterSpacing: "0px",
    color: "#6B6B6B",
    textAlign: "left",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "10px",
    transform: "translate(0px,5px)" 
  },
  root: {
    backgroundColor: "rgba(0, 0, 0, 0)"
  },
  dialog: {
    position: "absolute",
    //width: "264px",
    overflow: "hidden",
    zIndex: "0",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "0px 0px 10px #00000029",
    borderRadius: "2px",
    direction: window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA" ? "rtl" : "ltr"
  },
  dialogTitle: {
    //width: "264px",
    height: "39px",
    padding: "2px 10px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "0px 0px 10px #00000029",
    borderRadius: "2px",
    opacity: 1
  },
  dialogHead: {
    paddingRight: "10px",
    textAlign: window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA" ? "right" : "left",
    font: "normal normal bold 14px/17px Open Sans",
    letterSpacing: "0px",
    color: "#0072C6",
    opacity: 1
  },
  controlHead: {
    textAlign: "left",
    font: "normal normal 600 12px/16px Open Sans",
    letterSpacing: "0px",
    color: "#000000",
    opacity: 1
  },
  dialogContent: {
    padding: "11px"
    //width: "264px",
  },
  dialogActions: {
    height: "28px",
    width: "100%",
    background: "#F5F5F5 0% 0% no-repeat padding-box",
    opacity: 1,
    margin: "0px",
    padding: "0px"
    //padding: "11px 19px 11px",
  },
  divider: {
    backgroundColor: "#E4E4E4"
  },
  btn1: {
    minWidth: "88px",
    width: "33.33%",
    height: "28px",
    margin: "0px !important",
    padding: "5px 0px 0px 0px",
    background: "#E6E6EB 0% 0% no-repeat padding-box",
    font: "normal normal 600 10px/16px Open Sans",
    color: "#000000",
    textAlign: "center",
    letterSpacing: "0px",
    opacity: 1,
    "&:hover": {
      cursor: "pointer"
    }
  },
  btn2: {
    minWidth: "88px",
    width: "33.33%",
    height: "28px",
    margin: "0px !important",
    padding: "5px 0px 0px 0px",
    background: "#E6E6EB 0% 0% no-repeat padding-box",
    font: "normal normal 600 10px/16px Open Sans",
    color: "#000000",
    textAlign: "center",
    letterSpacing: "0px",
    opacity: 1,
    "&:hover": {
      cursor: "pointer"
    }
  },
  btn3: {
    minWidth: "88px",
    width: "33.33%",
    height: "28px",
    margin: "0px !important",
    padding: "5px 0px 0px 0px",
    background: "#0072C6 0% 0% no-repeat padding-box",
    font: "normal normal 600 10px/16px Open Sans",
    color: "#ffffff",
    textAlign: "center",
    letterSpacing: "0px",
    opacity: 1,
    "&:hover": {
      cursor: "pointer"
    }
  }
});

function ElemDeleteControl(props) {
  const dispatch = useDispatch();
  const currentDeviceOnApp = getDevice()

  const [alertData, setAlertData] = useState({
    open: false,
    showConfirm: "showNotification"
  });
  const classes = useStyles();
  const [selectedControlCLone, setSelectedControlClone] = useState(cloneDeep(props.data));

  const [moreOpt, setMoreOpt] = useState(false);
  const [quick, setQuick] = useState(false);
  const [ok, setOk] = useState(false);
  const [value, setValue] = useState(false);

  const { t } = useTranslation();
  // const { t } = useTranslation(['styles','translation']);
  const [showGridSelector, setShowGridSelector] = useState(false);
  const [copying, setCopying] = useState(false);

  const [showImportSectionPopUp, setShowImportSectionPopUp] = useState(false);

  const [uploadedJson, setUploadedJson] = useState();
  const [savePageTemplate_popup, setSavePageTemplate_popup] = useState(false);

  const [fileName, setfileName] = useState("");
  const [isTableUpload, setIsTableUpload] = useState(false);
  const fileRef = useRef(null);
  const columnFileRef = useRef(null);
  const tableInputFile = useRef(null);
  const inputTabFile = useRef(null);
  const tileFileRef = useRef(null);
  let tileUploadNewColumn={};
  const [screenShot, setScreenshot] = useState();

  // useEffect(() => {
  //   // return () => {
  //   //   second;
  //   // };
  // }, [copying]);

  const contexts = GetStateFromData(props.containerId);
  const gridContexts = GetStateFromData(props.containerId,"data2");

  const {
    advanceListviewStateJson
  } = gridContexts.gridStates;

  const jwtToken = contexts.formMataData?.token;
  const {controlSelected} = GetState("controlSelected");
  const {
    updateJson,
    selectedControl,
    changeSectionLayout,
    setOpenProperties,
    formState2,
    handleSelected,
    setFormState2,
    device,
    openCanvasForSubform,
    setOpenQuickToolFor,
    setCopyElement,
    setOpenLoader,
    currentButtonForSubform,
    currentadvanceListview,
    setSubFormState,
    copyElement,
    // advanceListviewStateJson,
    subFormStateJson,
    setCurrElem,
    testClick,
    // setAdvanceListviewStateJson,
    microFrontendData,
    activePage,
    activeSubForm,
    setCurrentDataObjectJson,
    containerId,
    setGlobalLoading,
    setGlobalLoadingMessage

  } = contexts.contexts;
  const { updatedComponentInFormState, removeAndUpdateComponentInFormState } = updateJson;

  const isSubformInPage = props?.isSubformInPage || false;
  const inputFile = useRef(null);
  const uploadFrom = useRef(null);
  const translationStyles1 = window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA";
  const [layout, setLayout] = useState((findFrameColumnLayout(controlSelected, currentDeviceOnApp) || "") + "");
  const sectionBuffer =
    formState2 !== undefined
      ? formState2.children !== undefined
        ? formState2.children[1] !== undefined
          ? formState2.children[1]
          : ""
        : ""
      : "";
  // if(formState2)
  // if(formState2.children)
  // if(formState2.children[1]){
  // let sectionBuffer = formState2.children[1];
  // }
  // console.log('selected layout :: ',layout, selectedControl.ColumnLayout,selectedControl);

  useEffect(() => {
    if (controlSelected) {
      setLayout(findFrameColumnLayout(controlSelected, currentDeviceOnApp));
    }
  }, [JSON.stringify(controlSelected), device]);

  const setColumnLayout = (layout) => {
    setLayout(layout);
    changeSectionLayout(layout, props.data);
  };

  function getNoOfCols(){
    const columnLayout = getColumnLayout("web");
    return 12/columnLayout;
}

function getCurrentDevice(){
  const deviceFromDom=document.querySelector("#canvasId")?.getAttribute("deviceMode");
  return deviceFromDom;
}

  function handleDelete(ev) {
    var Id = ev.target.getAttribute("name");
    // alert(props.elemType );

    if (
      ev.currentTarget.closest(`[elem_type=wizard_v]`) ||
      ev.currentTarget.closest(`[elem_type=wizard_h]`) ||
      (ev.currentTarget.closest(`[elem_type=sidenavigation]`) && !ev.currentTarget.closest(`[elem_type=tab]`))
    ) {
      props.data["insideWizard"] = true;
    }

    if (
      (ev.currentTarget.closest(`[elem_type=Step]`) &&
        ev.currentTarget.closest(`[elem_type=Step]`).getAttribute("stepindex")) ||
      (ev.currentTarget.closest(`[elem_type=SubStep]`) &&
        ev.currentTarget.closest(`[elem_type=SubStep]`).getAttribute("stepindex"))
    ) {
      props.data["parentStep"] =
        (ev.currentTarget.closest(`[elem_type=Step]`) &&
          ev.currentTarget.closest(`[elem_type=Step]`).getAttribute("stepindex")) ||
        (ev.currentTarget.closest(`[elem_type=SubStep]`) &&
          ev.currentTarget.closest(`[elem_type=SubStep]`).getAttribute("stepindex")) ||
        "";
    }

    if (
      (ev.currentTarget.closest(`[elem_type=SubStep]`) &&
        ev.currentTarget.closest(`[elem_type=SubStep]`).getAttribute("substepindex"))
    ) {
      props.data["parentSubStep"] =
        (ev.currentTarget.closest(`[elem_type=SubStep]`) &&
          ev.currentTarget.closest(`[elem_type=SubStep]`).getAttribute("substepindex")) ||
        "";
    }

    if (document.querySelector(".menuMain_Id") !== null) {
      if (document.querySelector(".menuMain_Id").getAttribute("stepIndex")) {
        props.data["stepIndex"] = document.querySelector(".menuMain_Id").getAttribute("stepIndex") || "";
      }
    }

    if (ev.currentTarget.closest(`[elem_type=Menu]`)) {
      props.data["insideMenu"] = true;
    }
    if (
      props.elemType === "section" ||
      props.elemType === "frame" ||
      props.elemType === "tab" ||
      props.elemType === "sheet" ||
      props.elemType === "wizard_h" ||
      props.elemType === "wizard_v" ||
      props.elemType === "sidenavigation" ||
      props.elemType === "Menu" ||
      props.elemType === "table" ||
      props.elemType === "listview" ||
      props.elemType === "advancelistView" ||
      props.elemType === "advancelistview" ||
      props.elemType === "doclist"
    ) {
      setAlertData({
        open: true,
        showConfirm: "showconformationDialogBox",
        //'alertContentKey':'DeleteConfirmationContent',
        alertContentKey: `${t("DeleteConfirmationContent2")} ${
          props.isStep === "true"
            ? t("step")
            : props.elemType === "wizard_h"
            ? t("wizard horizontal")
            : props.elemType === "wizard_v"
            ? t("wizard vertical")
            : t(props.elemType)
        } ${t("DeleteConfirmationContentRest")}`,
        //'alertTitleKey':`${t("translation:DeleteConfirmationTitleDynamic")} ${props.elemType === "wizard_h" ? "wizard horizontal" :props.elemType === "wizard_v" ? "wizard vertical" : props.elemType}?`,
        alertTitleKey: `${t("DeleteConfirmation2")}`,
        Button1Key: "Close",
        Button2Key: "Delete",
        Id: Id,
        controlId: Id,
        data: props.data,
        evnt: ev,
        dynamicTitle: true
      });
    } else {
      // callForDelete(Id);
      callForDelete(ev, Id);
    }
  }

  window.deleteOnCut = function (id) {
    handleDelete(id);
  };

  function callForDelete(ev, Id) {
    var controlTobeDeletedDetails = {};
    // console.log(props);
    if (props.elemType === "tile") {
      props.deleteControl(ev, Id, props.data, props.index);
    }
    if (props.elemType !== "tile") {
      props.deleteControl(ev, Id, props.data);
    }
    //props.deleteControl(Id,props.data);
  }

  function handleMove(e) {
    console.log("nooo", props, e, controlSelected);
  }

  function handleSettings(e) {
    e.stopPropagation();
    console.log("nooo1", props, e, controlSelected);
    window.selectedControlId_function(controlSelected, controlSelected?.id);
    setOpenProperties(true);
  }

  let parentControl = undefined;
  let parentRowControl = undefined;
  let parentColControl = undefined;
  let foundParent = false;
  let foundControl = false;

  function initializeVars() {
    parentControl = undefined;
    parentRowControl = undefined;
    parentColControl = undefined;
    foundParent = false;
    foundControl = false;
  }

  function handleCopy() {
    //  console.log('Copy called!');
    setCopying(true);

    console.log("copy Data :: ", props.data);
    setCopyElement(props.data);
    initializeVars();
    // try{
    //   var formState = formState2;
    //   getParentOf(formState , props.data.id);
    //   // console.log("parentControl :: ", parentControl);
    //   // console.log(
    //   //   "| parentControl :: ",parentControl,
    //   //   "| parentRowControl :: ",parentRowControl,
    //   //   "| parentColControl :: ",parentColControl,
    //   //   "| foundParent :: ",foundParent,
    //   //   "| foundControl :: ",foundControl,
    //   // );

    //   if (parentControl) {
    //     var count = Object.keys(parentControl).length;
    //     var populateInside = {};
    //     if(count>0){
    //       populateInside = {
    //         id: parentControl["id"],
    //         elem_type: parentControl["elem_type"],
    //         frameIndex: parentControl["frameIndex"],
    //         elementIndex: parentControl["elementIndex"],
    //         sheetElementIndex: parentControl["sheetElementIndex"],
    //         sheetFrameElementIndex: parentControl["sheetFrameElementIndex"],
    //         sheetId: parentControl["sheetIndex"],
    //       };
    //     }
    //     let payload = {
    //       populateInside: populateInside,
    //       populateElem: props.data,
    //     };
    //     // console.log('Finalized Json :: ', payload , parentRowControl , parentColControl);
    //     sendRequestForControl(null, 'duplicate', null, payload)
    //     .then(
    //       (response) => {
    //         // console.log('Response :: ', response);
    //         let data = response.data;
    //         let _alert = data.alert;
    //         if(_alert){
    //           //customalert
    //           showAlertConfirmNotifications({
    //             'open':true,
    //             'showConfirm':'showNotification',
    //             'alertType':'error',
    //             'alertContentKey':`Alert ::  ${data}`
    //           });
    //           // alert('Alert :: '+ data);
    //         } else {
    //           let populatedJson = data.populatedJson;
    //           if(populatedJson!==null & populatedJson!==undefined)
    //             updateFormStateStructure(populatedJson);
    //         }
    //         setCopying(false);
    //         setQuickToolsClose(
    //           (prevState) => {
    //             if(prevState===true){
    //               return false;
    //             } else {
    //               return prevState;
    //             }
    //           }
    //         );
    //       }
    //     )
    //     .catch(
    //       (err) => {
    //         setCopying(false);
    //         setQuickToolsClose(
    //           (prevState) => {
    //             if(prevState===true){
    //               return false;
    //             } else {
    //               return prevState;
    //             }
    //           }
    //         );
    //         console.error('Error :: ', err);
    //       }
    //     );

    //   }
    // } catch(error) {
    //     console.log('Error :: ', error);
    // }
  }

  function handlePaste(ev){
    let targetElemState1 = {}
    targetElemState1["targetRowId"] = ""
    var formstate = formStateStore
      .getState()
      .data.find((json) => json.key === containerId)?.contexts?.formState2;
    if (Object.keys(copyElement?.current).length > 0) {
      var jsonObj = {};
      var extraDetails = {};
      let isSubForm = false;
      if (openCanvasForSubform === "subform") {
        isSubForm = true;
      }
      let isAdvanceListview = false;
      if (openCanvasForSubform === "advanceListviewFromScratch") {
        isAdvanceListview = true;
      }
      const parentWizard = (eve) => {
        if (
          eve?.currentTarget?.closest(`[elem_type=wizard_v]`) ||
          eve?.currentTarget?.closest(`[elem_type=wizard_h]`) ||
          (eve?.currentTarget?.closest(`[elem_type=sidenavigation]`) &&
            !eve?.currentTarget?.closest(`[elem_type=tab]`)) ||
          (openCanvasForSubform === "subform" &&
            currentButtonForSubform.current?.containerControl ===
              "wizard_h") ||
          (openCanvasForSubform === "subform" &&
            currentButtonForSubform.current?.containerControl ===
              "wizard_v") ||
          (openCanvasForSubform === "subform" &&
            currentButtonForSubform.current?.containerControl ===
              "sidenavigation")
        ) {
          return true;
        } else {
          return false;
        }
      };

      const parentMenu = () => {
        if (
          ev?.currentTarget?.closest(`[elem_type=Menu]`) ||
          (openCanvasForSubform === "subform" &&
            currentButtonForSubform.current?.containerControl === "Menu")
        ) {
          return true;
        } else {
          return false;
        }
      };
      const frameIndexget =
        ev.currentTarget
          ?.closest(`[elem_type=frame]`)
          ?.getAttribute("frameindex") ||
        ev.currentTarget
          ?.closest(`[elem_type=section]`)
          ?.getAttribute("frameindex") ||
        ev.currentTarget
          ?.closest(`[elem_type=form]`)
          ?.getAttribute("frameindex");

      let parentStep =
        (ev.currentTarget.closest(`[elem_type=Step]`) &&
          ev.currentTarget
            .closest(`[elem_type=Step]`)
            .getAttribute("frameindex")) ||
        (ev.currentTarget.closest(`[elem_type=SubStep]`) &&
          ev.currentTarget
            .closest(`[elem_type=SubStep]`)
            .getAttribute("frameindex")) ||
        "";
      if (parentWizard(ev)) {
        if (parentStep !== null) {
          targetElemState1["parentStep"] = parentStep;
          targetElemState1["insideWizard"] = parentWizard(ev);
          targetElemState1["stepIndex"] = copyElement.current.stepIndex;
          targetElemState1["subStepIndex"] = copyElement.current.subStepIndex;
          targetElemState1["parentSubStep"] = copyElement.current.subStepIndex;
        }
      } else if (parentMenu()) {
        targetElemState1["insideMenu"] = parentMenu();
        if (
          openCanvasForSubform === "subform" &&
          currentButtonForSubform.current?.containerControl === "Menu"
        ) {
          targetElemState1.stepIndex =
            currentButtonForSubform.current?.stepIndex ||
            currentButtonForSubform.current?.stepIndex === 0
              ? currentButtonForSubform.current?.stepIndex
              : "-1";
              targetElemState1.substepIndex =
            currentButtonForSubform.current?.subStepIndex ||
            currentButtonForSubform.current?.subStepIndex === 0
              ? currentButtonForSubform.current?.subStepIndex
              : "-1";
              targetElemState1.subChildMenuIndex =
            currentButtonForSubform.current?.subChildMenuIndex ||
            currentButtonForSubform.current?.subChildMenuIndex === 0
              ? currentButtonForSubform.current?.subChildMenuIndex
              : "-1";
        } else {
          targetElemState1["substepIndex"] = document
            .querySelector(".menuMain_Id")
            .getAttribute("substepIndex");
            targetElemState1["subChildMenuIndex"] = document
            .querySelector(".menuMain_Id")
            .getAttribute("subChildMenuIndex");
            targetElemState1["stepIndex"] = document
            .querySelector(".menuMain_Id")
            .getAttribute("stepIndex");
        }
      }
      console.log("parentStep", parentStep);
      targetElemState1["isSubForm"] = isSubForm;
      targetElemState1["isAdvanceListview"] = isAdvanceListview;
      targetElemState1["targetId"] = data.id;
      extraDetails["isSubForm"] = isSubForm;
      extraDetails["isAdvanceListview"] = isAdvanceListview;

      if (
        props?.data?.sheetIndex !== undefined ||
        props?.data?.sheetIndex !== ""
      ) {
        targetElemState1["sheetIndex"] = props?.data?.sheetIndex;
        targetElemState1["elementIndex"] = props?.data?.elementIndex;
      } else {
        delete targetElemState1.sheetIndex;
      }
    if(targetElemState1?.targetId?.includes("column")){
        let frameId = document.getElementById(targetElemState1?.targetId)?.closest(`[elem_type=frame]`)?.getAttribute('id');
        if(document.getElementById(targetElemState1?.targetId)?.closest(`[elem_type=tab]`))
            frameId = document.getElementById(targetElemState1?.targetId)?.closest(`[elem_type=tab]`)?.getAttribute('parentframeid');
        const populateInside = {
          id: frameId,
          elem_type :  parentWizard(ev) ? formState2.containerControl : "frame",
          elementIndex: data?.elementIndex,
          frameIndex: frameIndexget === null ? data?.frameIndex :frameIndexget,
          isSubForm: openCanvasForSubform === "subform",
          isAdvanceListview: openCanvasForSubform === "advanceListviewFromScratch"
        };
        let payload = {
          populateInside: parentWizard(ev)
            ? {
                ...populateInside,
                stepIndex:openCanvasForSubform === "subform"?  currentButtonForSubform?.stepIndex : openCanvasForSubform === "advanceListviewFromScratch" ? currentadvanceListview?.stepIndex : getStepIndex(),
                subStepIndex:openCanvasForSubform === "subform"? currentButtonForSubform?.subStepIndex : openCanvasForSubform === "advanceListviewFromScratch" ? currentadvanceListview?.subStepIndex : getSubStepIndex(),
                subChildMenuIndex:openCanvasForSubform === "subform"? currentButtonForSubform?.subChildMenuIndex : openCanvasForSubform === "advanceListviewFromScratch" ? currentadvanceListview?.subChildMenuIndex : getSubChildMenuIndex()
              }
            : data?.sheetId
            ? {
                ...populateInside,
                sheetElementIndex: data?.sheetElementIndex,
                sheetId: data?.sheetId
              }
            : populateInside,
          populateElem: {...copyElement.current, elem_type: copyElement?.current?.elem_type === "advancelistView" ? "advancelistview" : copyElement?.current?.elem_type}
        };
      let sheetData = {};
      if (
        props?.data?.sheetIndex !== undefined ||
        props?.data?.sheetIndex !== ""
      ) {
        sheetData["sheetIndex"] = props?.data?.sheetIndex;
        sheetData["elementIndex"] = props?.data?.elementIndex;
      }
      testClick(ev = {...ev, which: 86, ctrlKey: true},data,sheetData,targetElemState1);
      console.log(data, 'elseeeeeeeeee',copyElement,"targetElemState1",frameIndexget)
    }
    else{
      setCurrentDataObjectJson(cloneDeep({}));
      setAlertData({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        autoHideDuration: 3000,
        alertContentKey: "Please select a column before pasting",
      });
    }
    } else {
      setAlertData({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        autoHideDuration: 3000,
        alertContentKey: "Please copy controls",
      });
    }
  }

  let foundNextAvailableColFromParent = false;

  function getNextAvailableColFromParent(parent) {
    if (parent && Array.isArray(parent)) {
      parent.forEach((child) => {
        if (
          child &&
          !foundNextAvailableColFromParent &&
          child["elem_type"] === "column" &&
          child["children"].length === 0
        ) {
          foundNextAvailableColFromParent = child;
          return child;
          // else {
          //   return getNextAvailableColFromParent(child);
          // }
        } else if (!foundNextAvailableColFromParent) {
          return getNextAvailableColFromParent(child);
        }
      });
    } else if (parent) {
      if (
        parent["elem_type"] &&
        parent["elem_type"] === "column" &&
        parent["children"] &&
        parent["children"].length === 0 &&
        !foundNextAvailableColFromParent
      ) {
        return parent;
      } else {
        if (parent["children"] && !foundNextAvailableColFromParent)
          return getNextAvailableColFromParent(parent["children"]);
      }
    } else {
      //  console.log('Case not expected!');
    }
  }

  function updateFormStateStructure(populatedJson) {
    // updatedComponentInFormState(controlId, controlData);
    // console.log("populatedJson b4=>", populatedJson);
  updateRowNColumn(populatedJson);
    // console.log("populatedJson after=>", populatedJson);
    if (parentControl.id === "RootControl") {
      if (parentControl["children"]) {
        let indexOfReference = -1;
        for (let i = 0; i < parentControl["children"].length; i++) {
          if (parentControl["children"][i]["id"]) {
            if (parentControl["children"][i]["id"] === props.data.id) {
              indexOfReference = i;
            }
          }
        }
        parentControl["children"].splice(indexOfReference + 1, 0, populatedJson);
        updatedComponentInFormState(parentControl["id"], parentControl);
      }
    } else if (parentControl["elem_type"] === "frame" || parentControl["elem_type"] === "headerframe") {
      // parentRowControl
      // parentColControl
      let emptyColPresent = false;
      let indexOfParentCol;
      let indexOfEmptyCol;
      if (parentRowControl) {
        parentRowControl["children"] &&
          parentRowControl["children"].map((col, index) => {
            if (col["children"] && col["children"].length === 0) {
              emptyColPresent = true;
              indexOfEmptyCol = index;
            }
            if (col.id === parentColControl.id) {
              indexOfParentCol = index;
            }
          });
      }
      if (emptyColPresent) {
        let emptyCol = parentRowControl["children"][indexOfEmptyCol];
        // console.log("emptyCol :: ", emptyCol);
        parentRowControl["children"].splice(indexOfEmptyCol, 1);
        emptyCol["children"].push(populatedJson);
        parentRowControl["children"].splice(indexOfParentCol + 1, 0, emptyCol);
        updatedComponentInFormState(parentRowControl["id"], parentRowControl);
        // console.log("parentRowControl :: ", parentRowControl);
      } else {
        getNextAvailableColFromParent(parentControl);
        // console.log(
        //   "nextAvailableCol :: ",
        //   // nextAvailableCol,
        //   foundNextAvailableColFromParent
        // );
        if (foundNextAvailableColFromParent) {
          foundNextAvailableColFromParent["children"].push(populatedJson);
          updatedComponentInFormState(foundNextAvailableColFromParent["id"], foundNextAvailableColFromParent);
        } else {
          // let indexOfParentRow = -1;
          // for (let i = 0; i < parentControl["children"].length; i++) {
          //   if (parentControl["children"][i]["id"]) {
          //     if (parentRowControl && parentRowControl.id){
          //       if (
          //         parentControl["children"][i]["id"] === parentRowControl.id
          //       ) {
          //         indexOfParentRow = i;
          //       }
          //     }
          //     //  else {
          //     //   parentControl["children"].push(populatedJson);
          //     // }
          //   }
          // }

          let parentColLayout = parseInt(parentControl["ColumnLayout"]);
          let newRow = {};
          newRow["id"] = createUniqueId("row");
          newRow["elem_type"] = "row";
          newRow["frameIndex"] = parentControl["frameIndex"];
          newRow["parent_id"] = parentControl["id"];
          newRow["children"] = [];

          let newCol = {};
          newCol["id"] = createUniqueId("column");
          newCol["elem_type"] = "column";
          newCol["frameIndex"] = parentColControl["frameIndex"];
          newCol["children"] = [];
          // newCol["md"] = 4;
          // newCol["sm"] = 6;
          // newCol["w"] = 4;
          // newCol["xs"] = 12;
          newCol["md"] = 12 / parentColLayout;
          newCol["sm"] = 6;
          newCol["w"] = 12 / parentColLayout;
          newCol["xs"] = 12;

          newCol["children"].push(populatedJson);
          newRow["children"].push(newCol);

          for (let colIncr = 0; colIncr < parentColLayout - 1; colIncr++) {
            let emptyColObj = {};
            emptyColObj["id"] = createUniqueId("column");
            emptyColObj["elem_type"] = "column";
            emptyColObj["frameIndex"] = parentColControl["frameIndex"];
            emptyColObj["children"] = [];
            // emptyColObj["md"] = parentColControl["md"];
            // emptyColObj["sm"] = parentColControl["sm"];
            // emptyColObj["w"] = parentColControl["w"];
            // emptyColObj["xs"] = parentColControl["xs"];
            emptyColObj["md"] = 12 / parentColLayout;
            emptyColObj["sm"] = 6;
            emptyColObj["w"] = 12 / parentColLayout;
            emptyColObj["xs"] = 12;
            newRow["children"].push(emptyColObj);
          }

          // parentControl["children"].splice(indexOfParentRow + 1, 0, newRow);
          parentControl["children"].push(newRow);
          updatedComponentInFormState(parentControl["id"], parentControl);
        }

        // console.log("parentControl :: ", parentControl);
      }
    }
  }

  let controlsNotToConsiderAsParent = [
    // 'frame',
    // 'section',
    // 'headerframe',
    "row",
    "textbox",
    "column",
    "radio",
    "combo",
    "checkbox",
    "datepick",
    "email",
    // 'form',
    "phonenumber",
    "button",
    "textarea",
    "password",
    "listbox",
    "toggle",
    // 'tab',
    "multiSelect",
    "table",
    "listview",
    "advancelistview",
    "label",
    "link",
    "paragraph",
    "iframe",
    "picklist",
    "image",
    "doclist",
    "richtexteditor",
    "slider",
    "imagecarousel",
    "tile",
    // 'wizard_h',
    // 'wizard_v',
    // 'sidenavigation',
    "report",
    "CustomControl"
  ];

  function getParentOf(formState, controlID) {
    if (Array.isArray(formState)) {
      for (let child of formState) {
        if (!foundControl) {
          getParentOf(child, controlID);
          if (foundControl && child["elem_type"] === "column") {
            parentColControl = child;
          } else if (foundControl && child["elem_type"] === "row") {
            parentRowControl = child;
          } else if (
            !foundParent &&
            foundControl &&
            child["elem_type"] !== undefined &&
            !controlsNotToConsiderAsParent.includes(child["elem_type"]) &&
            child["id"] !== controlID
          ) {
            parentControl = child;
            foundParent = true;
          }
          return;
        }
      }
    } else {
      if (!foundControl) {
        if (formState.id === controlID) {
          foundControl = true;
          return;
        } else {
          if (formState["children"] && !foundControl) {
            return getParentOf(formState["children"], controlID);
          } else if (formState["children"] && !foundParent && foundControl) {
            if (formState["elem_type"] === "column") {
              parentColControl = formState;
              return;
            } else if (formState["elem_type"] === "row") {
              parentRowControl = formState;
              return;
            } else {
              foundParent = true;
              parentControl = formState;
              return;
            }
          } else {
            return;
          }
        }
      } else {
        if (foundParent) {
          return parentControl;
        } else {
          if (controlsNotToConsiderAsParent.includes(formState["elem_type"])) {
            if (formState && formState["elem_type"] && formState["elem_type"] === "row") {
              if (parentRowControl === undefined) {
                parentRowControl = formState;
                return;
              }
            } else if (formState && formState["elem_type"] && formState["elem_type"] === "column") {
              if (parentColControl === undefined) {
                parentColControl = formState;
                return;
              }
            } else {
              return getParentOf(formState["children"], controlID);
            }
          } else {
            if (
              foundParent === false &&
              foundControl &&
              parentRowControl !== undefined &&
              parentColControl !== undefined
            ) {
              parentControl = formState;
              foundParent = true;
            } else {
              return getParentOf(formState["children"], controlID);
            }
          }
        }
      }
    }
  }

  function handleGrid() {
    //  console.log("showGridSelector :: ", showGridSelector);
    console.log(selectedControl, "propssss===>>", props);
    setShowGridSelector(true);
  }

  function handleDownload() {}

  function handleMore() {}

  var parent_id = props.data.id;
  var data = props.data;
  if (parent_id === "RootControl") {
    parent_id = props?.parentframeId;
  }

  const checkContainer = (uploadFrom, data, sheetId) => {
    let elemType = uploadFrom === "column" ? "frame" : data.elem_type;

    if (formState2?.containerControl) {
      elemType = formState2?.containerControl?.toLowerCase();
    }
    if (data.sheetId || sheetId) {
      elemType = "frame";
    }
    return elemType;
  };

  const getIds = () => {
    let sectionId = "";
    let sheetId = "";
    let tabId = "";
    const column = document.getElementById(props?.data?.id);

    if (column) {
      const frame = column.closest(`[elem_type=frame]`);
      const sheet = column.closest(`[elem_type=tabChild]`);
      const tab = column.closest(`[elem_type=tab]`);

      if (frame) {
        sectionId = frame.getAttribute("id");
      }
      if (sheet) {
        sheetId = sheet.getAttribute("id");
      }
      if (tab) {
        tabId = tab.getAttribute("id");
      }
    }
    return { sectionId, sheetId, tabId };
  };

  const handleUploadControls = (uploadFrom, theFile, uploadedJson) => {
    // setGlobalLoading(true)
    // setGlobalLoadingMessage("Importing...")
    window.loading(true);
    const { sectionId, sheetId, tabId } = getIds();
    let JsonForTile;
    if (sectionId && uploadFrom==="tile") {
      JsonForTile = recursiveJsonReader1(formState2, sectionId);
    }    
    if (sheetId && uploadFrom==="tile") {
      JsonForTile = recursiveJsonReader1(formState2, sheetId);
    }
    
    let data = uploadFrom==="tile" ? JsonForTile:props.data;
    uploadedJson.elementIndex = "";
    // const ColumnLayout = parseInt(data.ColumnLayout);
    // const length = data.children[0].children.length;
    // const targetColumn = data.children[0].children[length - 1].id
    let [targetColumn, flag] = uploadFrom === "column" ? [data, 1] : findJson(data, "column");
    if(uploadFrom==="tile" && sheetId){
      data=targetColumn;
    }

    var targetColumnIdd = targetColumn?.id || undefined;
    if(uploadFrom==="tile" && Object.keys(targetColumn).length===0){
      flag=1;
    }

    if(uploadedJson?.insideSectionColumn){
      delete uploadedJson?.insideSectionColumn
    }
    if(uploadedJson?.insideTabColumn){
      delete uploadedJson?.insideTabColumn
    }
    // const isEmpty =
    //   data.children[0].children[length - 1].children.length === 0
    //     ? true
    //     : false;
    if (!flag) {
      setOk(true);
    }

    if (flag || ( targetColumnIdd===undefined && !flag )) {
      let sectionJSON;
      let sheetJSON;
      let tabJSON;
      if (uploadFrom === "column" || (uploadFrom ==="tile" && sheetId)) {
        if (sectionId) {
          sectionJSON = recursiveJsonReader1(formState2, sectionId);
        }
        if (sheetId) {
          sheetJSON = recursiveJsonReader1(formState2, sheetId);
        }
        if (tabId) {
          tabJSON = recursiveJsonReader1(formState2, tabId);
        }
      }

      const elem_type = checkContainer(uploadFrom, data, sheetId);
      const populateInside = {
        id: sectionId || data.id,
        elem_type,
        elementIndex: (uploadFrom === "column" || uploadFrom==="tile") && sheetId ? tabJSON?.elementIndex : data?.elementIndex,
        frameIndex: (uploadFrom==="tile" && Object.keys(targetColumn).length===0) ? tileUploadNewColumn?.children[0]?.frameIndex || tileUploadNewColumn?.children[0]?.children[0]?.frameIndex : data?.frameIndex,
        isSubForm: openCanvasForSubform === "subform",
        isAdvanceListview: openCanvasForSubform === "advanceListviewFromScratch"
      };

      const isWizard =
        formState2.containerControl === "wizard_h" ||
        formState2.containerControl === "wizard_v" ||
        formState2.containerControl === "sidenavigation" ||
        formState2.containerControl === "Menu";

      if(uploadedJson?.elem_type === "tab" && props?.data?.elem_type === "frame" &&
      (uploadFrom !== "column" || uploadFrom !=="tile")){
        const gotcha = document.getElementById(props?.data?.id);
       if (
      !(
       gotcha?.closest(`[elem_type=tabChild]`) ||
       gotcha?.closest(`[elem_type=Menu]`) ||
       gotcha?.closest(`[elem_type=wizard]`)
       )
     ) {
      populateInside["insideSectionColumn"] = true;
     } 
      }

      else if(uploadedJson?.elem_type === "tab" && sectionJSON?.elem_type === "frame" &&
      uploadFrom === "column"){
        const gotcha = document.getElementById(sectionJSON?.id);
        if(!(gotcha?.closest(`[elem_type=tabChild]`)
        || gotcha?.closest(`[elem_type=Menu]`)
        || gotcha?.closest(`[elem_type=wizard]`))){
          populateInside["insideSectionColumn"] = true
        }
      }

      let payload = {
        populateInside: isWizard
          ? {
              ...populateInside,
              stepIndex:openCanvasForSubform === "subform"?  currentButtonForSubform?.stepIndex : openCanvasForSubform === "advanceListviewFromScratch" ? currentadvanceListview?.stepIndex : sectionJSON ? sectionJSON?.stepIndex : data?.stepIndex,
              subStepIndex:openCanvasForSubform === "subform"? currentButtonForSubform?.subStepIndex : openCanvasForSubform === "advanceListviewFromScratch" ? currentadvanceListview?.subStepIndex : sectionJSON ? sectionJSON?.subStepIndex : data?.subStepIndex,
              subChildMenuIndex:openCanvasForSubform === "subform"? currentButtonForSubform?.subChildMenuIndex : openCanvasForSubform === "advanceListviewFromScratch" ? currentadvanceListview?.subChildMenuIndex : sectionJSON ? sectionJSON?.subChildMenuIndex : data?.subChildMenuIndex
            }
          : sheetId
          ? {
              ...populateInside,
              sheetElementIndex: data?.sheetElementIndex,
              sheetId: sheetJSON?.sheetIndex || data.sheetId
            }
          : populateInside,
        populateElem: uploadedJson
      };


      const insideTabColumn = document.querySelector(`#${data?.id}`)?.closest(`[elem_type=tab]`) && !document.querySelector(`#${data?.id}`)?.closest(`[elem_type=frame]`);
      if (uploadedJson.elem_type !== "frame" || insideTabColumn) {
        sendRequestForControl(data.frameIndex, "import", uploadedJson.controlName || uploadedJson.elem_type, payload)
          .then((response) => {
            const controlElemToAdd = response.data.populatedJson;
            updateRowNColumn(controlElemToAdd);
            if (uploadFrom === "column") {
              if (isWizard) {
                controlElemToAdd.stepIndex =openCanvasForSubform === "subform"? currentButtonForSubform?.stepIndex : sectionJSON ? sectionJSON?.stepIndex : data?.stepIndex;
                controlElemToAdd.subStepIndex =openCanvasForSubform === "subform"? currentButtonForSubform?.subStepIndex : sectionJSON ? sectionJSON?.subStepIndex : data?.subStepIndex;
                controlElemToAdd.subChildMenuIndex =openCanvasForSubform === "subform"? currentButtonForSubform?.subChildMenuIndex : sectionJSON ? sectionJSON?.subChildMenuIndex : data?.subChildMenuIndex;
                controlElemToAdd.containerControl = formState2.containerControl;
              }
              if(controlElemToAdd.elem_type) {
                controlElemToAdd.elem_type = controlElemToAdd.elem_type.toLowerCase();
              }
              if (sheetId || data.sheetId) {
                controlElemToAdd.sheetId = sheetId || data.sheetId;
              }
              if (props?.data?.children?.length === 0) {
                props.data.children = [controlElemToAdd];
              } else if (props?.data?.children?.length > 0) {
                props.data.children.push(controlElemToAdd);
              }
            } 
            else if(uploadFrom === "tile"){
              if (isWizard) {
                controlElemToAdd.stepIndex =openCanvasForSubform === "subform"? currentButtonForSubform?.stepIndex : openCanvasForSubform === "advanceListviewFromScratch" ? currentadvanceListview?.stepIndex : sectionJSON ? sectionJSON?.stepIndex : data?.stepIndex;
                controlElemToAdd.subStepIndex =openCanvasForSubform === "subform"? currentButtonForSubform?.subStepIndex : openCanvasForSubform === "advanceListviewFromScratch" ? currentadvanceListview?.subStepIndex : sectionJSON ? sectionJSON?.subStepIndex : data?.subStepIndex;
                controlElemToAdd.subChildMenuIndex =openCanvasForSubform === "subform"? currentButtonForSubform?.subChildMenuIndex : openCanvasForSubform === "advanceListviewFromScratch" ? currentadvanceListview?.subChildMenuIndex : sectionJSON ? sectionJSON?.subChildMenuIndex : data?.subChildMenuIndex;
                controlElemToAdd.containerControl = formState2.containerControl;
              }
              if (sheetId || data.sheetId) {
                controlElemToAdd.sheetId = sheetId || data.sheetId;
              }
              if (targetColumn?.children?.length === 0) {
                targetColumn.children = [controlElemToAdd];
              }
              else 
              {
                var noOfCols = getNoOfCols() || parseInt(controlElemToAdd.ColumnLayout);
                var col = {};
                col.children=[controlElemToAdd];
                col.id = createUniqueId('column');//newElement;
                col.elem_type = 'column';
                const w = 12 / parseInt(noOfCols);
                col.w = getColumnLayout("web");
                col.md = getColumnLayout( getCurrentDevice() || "web");
                col.sm = getColumnLayout("tablet");
                col.xs = getColumnLayout("mobile");                
                col.style = {};
                col.style["heightselect"] = "set";
                col.style["Enable"]="true";
                col.style["ReadOnlyStyle"]="false";              
                col.frameIndex = controlElemToAdd.frameIndex;
                tileUploadNewColumn.children.push(col);
                targetColumn=tileUploadNewColumn;                               
              }              
            }
            else {

              var rowJson = {};
              window.containerSizesOnDrop.column_size_web = data?.w
              window.containerSizesOnDrop.column_size_tablet = data?.sm
              window.containerSizesOnDrop.column_size_mobile = data?.xs
              let jsonObj;
              if( targetColumnIdd===undefined ){
                rowJson = activeIdJson(data,"row");

                var noOfCols = getNoOfCols() || parseInt(controlElemToAdd.ColumnLayout);
                var col = {};
                col.children=[controlElemToAdd];
                col.id = createUniqueId('column');//newElement;
                col.elem_type = 'column';
                const w = 12 / parseInt(noOfCols);
                col.w = getColumnLayout("web");
                col.md = getColumnLayout( getCurrentDevice() || "web");
                col.sm = getColumnLayout("tablet");
                col.xs = getColumnLayout("mobile");                
                col.style = {};
                col.style["heightselect"] = "set";
                col.style["Enable"]="true";
                col.style["ReadOnlyStyle"]="false";              
                col.frameIndex = controlElemToAdd.frameIndex;
                // col.children.push(controlElemToAdd);
                if (openCanvasForSubform === "subform") {
                  jsonObj = createSmartFormState(
                    subFormStateJson,
                    rowJson.id,
                    "row",
                    "column",
                    0,
                    data.frameIndex,
                    col,
                    "",
                    device
                  );
                } else if (
                  openCanvasForSubform ===
                  "advanceListviewFromScratch"
                ) {
                  jsonObj = createSmartFormState(
                    fetchGridStates()?.advanceListviewStateJson,
                    rowJson.id,
                    "row",
                    "column",
                    0,
                    data.frameIndex,
                    col,
                    "",
                    device
                  );
                } else {
                  jsonObj = createSmartFormState(
                    formState2,
                    rowJson.id,
                    "row",
                    "column",
                    0,
                    data.frameIndex,
                    col,
                    "",
                    device
                  );
              }
              }
              else{

                if (openCanvasForSubform === "subform") {
                  jsonObj = createSmartFormState(
                    subFormStateJson,
                    targetColumn.id,
                    "column",
                    controlElemToAdd.controlName === "password" && controlElemToAdd.elem_type === "textbox"
                      ? "textbox"
                      : controlElemToAdd.controlName || controlElemToAdd.elem_type,
                    0,
                    data.frameIndex,
                    controlElemToAdd,
                    "",
                    device
                  );
                } else if (
                  openCanvasForSubform ===
                  "advanceListviewFromScratch"
                ) {
                  jsonObj = createSmartFormState(
                    fetchGridStates()?.advanceListviewStateJson,
                    targetColumn.id,
                    "column",
                    controlElemToAdd.controlName === "password" && controlElemToAdd.elem_type === "textbox"
                      ? "textbox"
                      : controlElemToAdd.controlName || controlElemToAdd.elem_type,
                    0,
                    data.frameIndex,
                    controlElemToAdd,
                    "",
                    device
                  );
                } else {
                jsonObj = createSmartFormState(
                  formState2,
                  targetColumn.id,
                  "column",
                  controlElemToAdd.controlName === "password" && controlElemToAdd.elem_type === "textbox"
                    ? "textbox"
                    : controlElemToAdd.controlName || controlElemToAdd.elem_type,
                  0,
                  data.frameIndex,
                  controlElemToAdd,
                  "",
                  device
                );
              }
              }

              // setOpenQuickToolFor(controlElemToAdd?.id);

              if (openCanvasForSubform === "subform") {
                setSubFormState({ ...jsonObj });
              } else if (
                openCanvasForSubform ===
                "advanceListviewFromScratch"
              ) {
                dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: { ...jsonObj }, renderCanvas: true }));
              } else {
                updatedComponentInFormState()
              }
              setOpenLoader(false);
              window.loading(false);
              return;
            }
            // jsonObj =  createSmartFormState(formState2, targetElemState.targetId, targetElemState.targetElemType,
            //   controlElemToAdd.controlName === "password" && controlElemToAdd.elem_type === "textbox" ? "textbox" : currElemState,
            //   0, targetElemState.frameIndex, controlElemToAdd, targetElemState.targetRowId, device );
            // startTransition(() =>{

            // jsonObj.id.closest(`[elem_type=row]`).nextsibling
            // setFormState2({...jsonObj});
            // if(openCanvasForSubform === "subform" && uploadFrom==="tile"){
              // setOpenQuickToolFor(controlElemToAdd?.id);

              updatedComponentInFormState(data?.id,data);    
            // }
          
            setOpenLoader(false);
            window.loading(false);
          })
          .catch((err) => {
            setOpenLoader(false);
            window.loading(false)
            setGlobalLoading(false)
            setGlobalLoadingMessage("")

            if(err?.response?.data?.error === "Can't upload advance listview or frame which contains advance listview inside a subform") {
              setAlertData({
                open: true,
                showConfirm: "showNotification",
                alertType: "error",
                alertContentKey: "Advance Listview cannot be imported in button subform",
                autoHideDuration: 4000
              });
            } else {
              setAlertData({
                open: true,
                showConfirm: "showNotification",
                alertType: "error",
                alertContentKey: `${t('Invalid_Operation')}`
              });
            }
            console.log("UploadItem", err);
          });
      } 
      else {
        setAlertData({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: `${t('SECTION_DROP_MESSAGE')}`
        });
        setGlobalLoading(false)
        setGlobalLoadingMessage("")
        setOpenLoader(false);
        window.loading(false);
      }
    } 
    else if (!flag && ok) {
      const val = checkIt(theFile);
      if (val) {
        // setValue(true)
        const after_row = document.getElementById("after_" + props.data.children[0].id);
        if (after_row !== null && after_row !== undefined) {
          const extraDetails = {
            isAdvanceListview: false,
            isSubForm: false
          };
          const targetElemState = {
            elementIndex: "",
            frameIndex: data.frameIndex,
            insideWizard: false,
            isAdvanceListview: false,
            isSubForm: false,
            parentStep: "",
            parentSubStep: "",
            // targetClass: "ROW_afterRow__3GqEd highlightedRow",
            targetElemType: data.elem_type,
            targetId: data.id,
            targetRowId: `after_${props.data.children[0].id}`
          };
          after_row.setAttribute("control_id", props.data && parent_id);
          if (uploadedJson.elem_type !== "frame") {
            sendRequestForControl(
              data.frameIndex,
              "add",
              uploadedJson.controlName || uploadedJson.elem_type,
              targetElemState,
              extraDetails
            )
              .then((response) => {
                var controlElemToAdd = response.data;
                updateRowNColumn(controlElemToAdd);
                // setOpenQuickToolFor(controlElemToAdd?.id)
                const jsonObj = createSmartFormState(
                  formState2,
                  data.id,
                  data.elem_type,
                  controlElemToAdd.controlName === "password" && controlElemToAdd.elem_type === "textbox"
                    ? "textbox"
                    : controlElemToAdd.controlName || controlElemToAdd.elem_type,
                  0,
                  data.frameIndex,
                  controlElemToAdd,
                  `after_${props.data.children[0].id}`,
                  device
                );
                updatedComponentInFormState();
                // setOpenQuickToolFor(controlElemToAdd?.id);
                setOpenLoader(false);
                setGlobalLoading(false)
                setGlobalLoadingMessage("")
              })
              .catch((err) => {
                setOpenLoader(false);
                window.loading(false)
                setGlobalLoading(false)
                setGlobalLoadingMessage("")
              });
          } else if (uploadedJson.elem_type === "frame") {
            setAlertData({
              open: true,
              showConfirm: "showNotification",
              alertType: "error",
              alertContentKey: "Section can be dropped in Tabs, Wizard and Forms only !"
            });
            setGlobalLoading(false);
            setGlobalLoadingMessage("");
            setOpenLoader(false);
            window.loading(false);
          }
        }
      }
    }
    else{
      setGlobalLoading(false)
      setGlobalLoadingMessage("")
      setOpenLoader(false);
      window.loading(false);
    }
  };

  var foundjson = {};
  let flag = 0;

  function findJson(formStatejson, activeId) {
    if (
      formStatejson !== undefined &&
      formStatejson !== null &&
      activeId !== "" &&
      activeId !== undefined &&
      activeId !== null
    ) {
      if (formStatejson.elem_type === activeId) {
        foundjson = formStatejson;
        return [foundjson, flag];
      } else {
        if (formStatejson.children !== undefined && formStatejson.children !== null) {
          formStatejson.children.map((child) => {
            if (child !== null && child !== undefined && child.elem_type !== null && child.elem_type !== undefined) {
              if (child.elem_type === activeId) {
                // if(child.children)
                if (child.children.length === 0 && flag === 0) {
                  foundjson = child;
                  flag = 1;
                }
                else{
                  // flag=1;
                  tileUploadNewColumn=formStatejson;
                }
              } else if (isObjectEmpty(foundjson)) {
                findJson(child, activeId);
              }
            }
          });
        }
      }
      return [foundjson, flag];
    }
  }

  function activeIdJson(formStatejson, activeId) {
    if (formStatejson && activeId) {
      if (formStatejson.elem_type === activeId) {
        foundjson = formStatejson;
      } 
      else {
        if (formStatejson.children && formStatejson.children.length) {
          formStatejson.children.map((child) => {
            if (child && child.elem_type) {
              if (child.elem_type === activeId) {
                foundjson = child;
              } 
              else if (isObjectEmpty(foundjson)) {
                activeIdJson(child, activeId);
              }
            }
          });
        }
      }
      return foundjson;
    }
  }

  function checkIt(theFile) {
    // Check if the number of files
    // is not zero
    if (theFile)
      if (theFile.value.length) {
        return true;
      }
      // Alert the user if the number
      // of file is zero
      else {
        return false;
      }
    // document.body.onfocus = null;
  }
  const onButtonClickTableUpload = (evt,upload) => {
    evt.stopPropagation();
    tableInputFile.current.click();
    uploadFrom.current = upload;
    //  console.log("test click called button clicked")
  };

  const onButtonClick = (evt,upload) => {
    evt.stopPropagation();
    inputFile.current.click();
    uploadFrom.current = upload;
    // handleSelected(evt,props?.id,"n")
    //  console.log("test click called button clicked")
  };
  const onTileClick = (evt) => {
    evt.stopPropagation();
    tileFileRef.current.click();
    //  console.log("test click called button clicked")
  };

  const onButtonClick1 = (evt) => {
    evt.stopPropagation();
    fileRef.current.click();
    //  console.log("test click called button clicked")
  };
  const onButtonClickColumn = (evt) => {
    evt.stopPropagation();
    columnFileRef.current.click();
    //  console.log("test click called button clicked")
  };

  const onButtonClick2 = (evt) => {
    evt.stopPropagation();
    inputTabFile.current.click();
    //  console.log("test click called button clicked")
  };

  const handleImportControls = (e, uploadFrom, elementId) => {
    try {
      const file = e.target.files[0];
      const theFile = document.getElementById(elementId);
      const fileReader = new FileReader();
      fileReader.readAsText(file, "UTF-8");
      fileReader.onload = (e) => {
        const parseJson = JSON.parse(e.target.result);
        // setUploadedJson(parseJson);
        const size = new TextEncoder().encode(e.target.result).length;
        const kiloBytes = size / 1024;

        handleUploadControls(
          uploadFrom,
          theFile,
          parseJson.elem_type === "advancelistView"
            ? { ...parseJson, elem_type: parseJson.elem_type.toLowerCase() }
            : parseJson
        );
        e.target.value = "";
      };
    } catch (err) {
      console.error(err);
    }
  };

  function uploadJson(evt, uploadFrom) {
    //  console.log("upload Image", evt.target.files);
    try {
      let files = evt.target.files;
      if (!files.length) {
        //customalert
        setAlertData({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: "NO_FILE",
          autoHideDuration: 4000
        });
        // alert('No file selected!');
        return;
      }
      let file = files[0];
      if (file.type === "application/json") {
        let reader = new FileReader();
        // const self = this;

        // file 100kb

        reader.onload = (evt) => {
          // var parseJson = JSON.parse(EventTarget.target.result);

          var parseJson = JSON.parse(evt.target.result);
          setUploadedJson(parseJson);

          //  console.log("uploading section in the form ", parseJson );

          const size = new TextEncoder().encode(evt.target.result).length;
          const kiloBytes = size / 1024;

          // console.log("target files", kiloBytes);

          // console.log("parseJson", parseJson);
          if (uploadFrom === "table" || uploadFrom === "listview") {
            if (parseJson["elem_type"] !== "table" && parseJson["elem_type"] !== "listview") {
              console.error("Only Table type control can be uploaded!");
              return;
            } else {
              setShowImportSectionPopUp(true);
              setIsTableUpload(true);
              setfileName(file.name);
            }
          } else {
            if (uploadFrom === "tab" && parseJson["elem_type"] !== "tab" && parseJson["elem_type"] !== "frame") {
              // alert('')
              setAlertData({
                open: true,
                showConfirm: "showNotification",
                alertType: "error",
                alertContentKey: `${t("Only Tab and Section type control can be uploaded!")}`
              });
              console.error("Only Tab type control can be uploaded!");
              return;
            }
            if (uploadFrom === "sheet" && parseJson["elem_type"] !== "sheet") {
              // alert('')
              setAlertData({
                open: true,
                showConfirm: "showNotification",
                alertType: "error",
                alertContentKey: `${t("Only sheet type control can be uploaded!")}`
              });
              console.error("Only sheet type control can be uploaded!");
              return;
            }

            if (uploadFrom === "section" || uploadFrom === "tab") {
              //setfileName

              setShowImportSectionPopUp(true);
              setfileName(file.name);

              //  console.log("uploading section in the form ");
            }
            // console.log("parseJson", formState2);
            var jsonToSend = {
              populateInside: {
                // id:formState2.id,
                // elem_type:formState2.elem_type,
                frameIndex: props.data.frameIndex || "",
                elementIndex: props.data.elementIndex || "",
                sheetElementIndex: props.data.sheetElementIndex || "",
                sheetElementFrameIndex: props.data.sheetElementFrameIndex || "",
                sheetId: props.data.sheetIndex || ""
              },
              populateElem: parseJson
              //whatever the user is uploading will be this json
              //  }
            };

            // console.log("parseJson", jsonToSend);

            var remainingURL = "/idesign/mappingTextbox";
          }
          // axios.post(remainingURL, jsonToSend, { withCredentials: true })
          // .then((response) => {
          //   if (response && response.data && response.status === 200) {

          //     console.log("yes It is Ok");

          //   }
          // });
        };
        reader.readAsText(file);
      } else {
        setAlertData({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: "INVALID_FRAMEFILE_TYPE"
        });
      }
      evt.target.value = "";
    } catch (err) {
      console.error(err);
    }
  }

  const handleSaveTemplate = async (e) => {
    e.stopPropagation();
    // const screenShot_in = await window.takeScreenshot();
    html2canvas(document.getElementById(`${props?.id}`), {
      allowTaint: true,
      useCORS: true
    })
      .then(function (canvas) {
        // It will return a canvas element
        let image = canvas.toDataURL("image/png", 0.5);
        setScreenshot(image);
        console.log("image", image, typeof image);
      })
      .catch((e) => {
        // Handle errors
        console.log(e);
      });
    setSavePageTemplate_popup(true);
  };

  function testinghandler(e) {
    e.stopPropagation();
  }

  function handleCancel() {
    //selectedControl = selectedControl;
    //WORK_ON_THIS
    // updatedComponentInFormState(selectedControl.id, selectedControl);
    // changeSectionLayout(selectedControlCLone.ColumnLayout,props.data);
    changeSectionLayout(findFrameColumnLayout(selectedControlCLone, currentDeviceOnApp), props.data);
    setLayout(findFrameColumnLayout(selectedControlCLone, currentDeviceOnApp))
    setShowGridSelector(false);
  }

  function handleView() {
    setOpenProperties(true);
    setShowGridSelector(false);
  }

  function handleDone() {
    try {
      if (selectedControl || props.data) {
        //   selectedControl.ColumnLayout = layout;
        //   updatedComponentInFormState(selectedControl.id, selectedControl);
        console.log(props.data, "selectedConyeee", selectedControl);
        changeSectionLayout(layout, props.data);
        setShowGridSelector(false);
        window.selectedControlId_function({});
      } else {
        console.error("No data passed as prop.");
      }
    } catch (e) {
      console.error(e);
    }
  }

  var copyClass = classes.icons;
  if (copying) {
    // copyClass = copyClass+' disableCopy';
    //copyClass = copyClass;
  } else {
    copyClass = classes.icons;
  }

  

  var postionForDiffLang = {
    position: props.hello !== undefined ? "inherit" : "absolute",
    left: window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA" ? "auto" : "-1px",
    right: window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA" ? "-1px" : "auto",
    // left:t("leftVal"),
    // right:t("rightVal"),
    // top: props.top === "Vertical" || props.top === "Horizontal" ? "-11px" : null,
    width: "max-content",
    top: ( props?.elemType==="wizard_h" && props?.id && props?.id?.toLowerCase()?.includes("step") ) ? "0" : ""
  };

  const returnInputFiles = () => {
    return (
      <>
        <input
        aria-label={"Upload JSON1"}
        type="file"
        id="file"
        ref={inputFile}
        onClick={(e) => e.stopPropagation()}
        style={{ display: "none" }}
        onChange={(e) => uploadJson(e, uploadFrom.current)}
        accept="application/JSON"
      />
      <input
        aria-label={"Import Control"}
        id="myFileColumn"
        hidden
        ref={columnFileRef}
        type="file"
        onChange={(e) => handleImportControls(e, "column", "myFileColumn")}
        accept=".json,application/json"
      />
      <input
        aria-label={"Import Tile"}
        id="myFileTile"
        hidden
        ref={tileFileRef}
        type="file"
        onChange={(e) => handleImportControls(e, "tile", "myFileTile")}
        accept=".json,application/json"
      />
      <input
        aria-label={"Upload JSON2"}
        type="file"
        id="file"
        ref={inputTabFile}
        style={{ display: "none" }}
        onChange={(e) => uploadJson(e, "tab")}
        accept="application/JSON"
      />
      <input
          aria-label={"Import Control"}
          id="myFile"
          hidden
          ref={fileRef}
          type="file"
          onChange={(e) => handleImportControls(e, "section", "myFile")}
          accept=".json,application/json"
        />
        <input
            aria-label={"Upload JSON3"}
            type="file"
            id="file"
            ref={tableInputFile}
            style={{ display: "none" }}
            onChange={(e) => uploadJson(e, uploadFrom.current)}
            accept="application/JSON"
          />
        </>
    );
  }

  return (
    <>
      {!isSubformInPage && (
        <>
          {returnInputFiles()}
          <div
            // draggable={true}
            // onDragStart={handleReorderStart}
            // onDrop={(ev)=>handleReorderDrop(ev,elemType)}
            id={props?.id + "_elemDeleteControl"}
            className={`${openCanvasForSubform === "showDataAdditonSection" || props?.data?.isInsideListview ? styles2.elementSelect2Listview : styles2.elementSelect2} elemDeleteControl`}
            style={postionForDiffLang}
          >
            {props.elemType === " " ||
            props.elemType === "frame" ||
            props.elemType === "sheet" ||
            props.elemType === "step" ? (
              <b>
                {/* {console.log("type1", props.elemType)} */}
                {/* {id}  */}
                {openCanvasForSubform === "showDataAdditonSection" || props?.data?.isInsideListview ? <></> : <img
                  src={require("../../Icons/QuickProperties/move.svg").default}
                  title={t("move")}
                  draggable={true}
                  onDragStart={(e) => props.handleReorderStart(e, props.dragId, props.dragType)}
                  onDrop={(ev) => props.handleReorderDrop(ev, props.elemType)}
                  onClick={handleMove}
                  className={classes.icons + " moveCss"}
                  alt="Move Icon"
                /> }
                {openCanvasForSubform === "showDataAdditonSection" || props?.data?.isInsideListview ? <></> : <img
                  src={require("../../Icons/QuickProperties/settings.svg").default}
                  title={t("settings")}
                  onClick={handleSettings}
                  className={classes.icons}
                  alt="Setting Icon"
                />}
                {openCanvasForSubform === "showDataAdditonSection" || props?.data?.isInsideListview ? <></> : <img
                  src={require("../../Icons/QuickProperties/grid.svg").default}
                  title={t("grid")}
                  onClick={handleGrid}
                  className={classes.icons}
                  alt="Grid Icon"
                />}
                
                {/* {copying ? (
                <img
                  src={require("../../Icons/QuickProperties/copy.svg").default}
                  title="copy"
                  // onClick={handleCopy}
                  className={copyClass}
                />
              ) : (
                <img
                  src={require("../../Icons/QuickProperties/copy.svg").default}
                  title="copy"
                  onClick={handleCopy}
                  className={classes.icons}
                />
              )} */}
              {openCanvasForSubform === "showDataAdditonSection" || props?.data?.isInsideListview ? <></> : <img
                  src={require("../../Icons/QuickProperties/download.svg").default}
                  title={t("download")}
                  onClick={() => downloadJson(props.data, props?.id)}
                  className={classes.icons}
                  alt="Download Icon"
                />}
                {openCanvasForSubform === "showDataAdditonSection" || props?.data?.isInsideListview ? <></> : <img
                  src={require("../../Icons/QuickProperties/deleteForever.svg").default}
                  name={props.tabParentId || props?.id}
                  title={t("delete")}
                  onClick={(ev) => handleDelete(ev)}
                  className={classes.icons}
                  alt="Delete Icon"
                />}
                

                {props.elemType === "wizard_h" || props.elemType === "wizard_v" || openCanvasForSubform === "showDataAdditonSection" || props?.data?.isInsideListview  || (props.elemType === "frame" && props?.id?.includes('table')) ? null : (
                  <img
                    src={require("../../Icons/QuickProperties/more.svg").default}
                    title={t("more")}
                    onClick={() => setMoreOpt(!moreOpt)}
                    className={classes.moreIcon}
                    alt="More Icon"
                  />
                )}
              </b>
            ) : props.elemType === "iframe" ? (
              <b style={props.index != undefined ? { display: "flex", width: "fit-content" } : {}}>
                {/* {console.log("type2", props.elemType)} */}
                <img
                  src={require("../../Icons/QuickProperties/move.svg").default}
                  title={t("move")}
                  draggable={true}
                  onDragStart={(e) => props.handleReorderStart(e, props.dragId, props.dragType)}
                  onDrop={(ev) => props.handleReorderDrop(ev, props.elemType)}
                  onClick={handleMove}
                  className={classes.icons + " moveCss"}
                  alt="Move Icon"
                />
                <img
                  src={require("../../Icons/QuickProperties/settings.svg").default}
                  title={t("settings")}
                  onClick={handleSettings}
                  className={classes.icons}
                  alt="Setting Icon"
                />
                <img
                  src={require("../../Icons/QuickProperties/download.svg").default}
                  title={t("download")}
                  onClick={() => downloadJson(props.data, props?.id)}
                  className={classes.icons}
                  alt="Download Icon"
                />
                <img
                  src={require("../../Icons/QuickProperties/deleteForever.svg").default}
                  name={props.tabParentId || props?.id}
                  title={t("delete")}
                  onClick={(ev) => handleDelete(ev)}
                  className={classes.icons}
                  alt="Delete Icon"
                />
              </b>
            ) : // props.elemType === "iframe" ||
            props.elemType === "subform" ||
              props.elemType === "wizard_h" ||
              props.elemType === "wizard_v" ||
              props.elemType === "sidenavigation" ||
              props.elemType === "table" ||
              props.elemType === "listview" ||
              props.elemType === "advancelistView" ||
              props.elemType === "advancelistview" ||
              props.elemType === "tile" ? (
              <b>
                {/* {console.log("type2", props.elemType)} */}
                {props.elemType === "tile" ? null : (
                  <img
                    src={require("../../Icons/QuickProperties/move.svg").default}
                    title={t("move")}
                    draggable={true}
                    onDragStart={(e) => props.handleReorderStart(e, props.dragId, props.dragType)}
                    onDrop={(ev) => props.handleReorderDrop(ev, props.elemType)}
                    onClick={handleMove}
                    className={classes.icons + " moveCss"}
                    alt="Move Icon"
                  />
                )}
                <img
                  src={require("../../Icons/QuickProperties/settings.svg").default}
                  title={t("settings")}
                  onClick={handleSettings}
                  className={classes.icons}
                  alt="Setting Icon"
                />
                {
                  props.elemType === "wizard_h" || props.elemType === "wizard_v" || props.elemType === "sidenavigation" || props.elemType === "report"? null :
                    <img
                      src={require("../../Icons/QuickProperties/download.svg").default}
                      title={t("download")}
                      onClick={() => downloadJson(props.data, props?.id)}
                      className={classes.icons}
                      alt="Download Icon"
                    />
                }
                <img
                  src={require("../../Icons/QuickProperties/deleteForever.svg").default}
                  name={props.tabParentId || props?.id}
                  title={t("delete")}
                  onClick={(ev) => handleDelete(ev)}
                  className={classes.icons}
                  alt="Delete Icon"
                />
                {props.elemType === "wizard_h" || props.elemType === "wizard_v" || props?.elemType?.toLowerCase() === "advancelistview" || props.elemType === "sidenavigation"? null : (
                  <img
                    src={require("../../Icons/QuickProperties/more.svg").default}
                    title={t("more")}
                    onClick={() => setMoreOpt(!moreOpt)}
                    className={[props.elemType === "tile" ? classes.icons : "",classes.moreIcon].join(" ")}
                    alt="More Icon"
                  />
                )}
              </b>
            ) : props.elemType === "tab" ||
              // props.elemType === "report" ||
              props.elemType === "doclist" ? (
              <b>
                <img
                  src={require("../../Icons/QuickProperties/move.svg").default}
                  title={t("move")}
                  draggable={true}
                  onDragStart={(e) => props.handleReorderStart(e, props.dragId, props.dragType)}
                  onDrop={(ev) => props.handleReorderDrop(ev, props.elemType)}
                  onClick={handleMove}
                  className={classes.icons + " moveCss"}
                  alt="Move Icon"
                />
                <img
                  src={require("../../Icons/QuickProperties/settings.svg").default}
                  title={t("settings")}
                  onClick={handleSettings}
                  className={classes.icons}
                  alt="Setting Icon"
                />
                {/* {copying ? (
                <img
                  src={require("../../Icons/QuickProperties/copy.svg").default}
                  title="copy"
                  // onClick={handleCopy}
                  className={copyClass}
                />
              ) : (
                <img
                  src={require("../../Icons/QuickProperties/copy.svg").default}
                  title="copy"
                  onClick={handleCopy}
                  className={classes.icons}
                />
              )} */}
                <img
                  src={require("../../Icons/QuickProperties/download.svg").default}
                  title={t("download")}
                  onClick={() => downloadJson(props.data, props?.id)}
                  className={classes.icons}
                  alt="Download Icon"
                />
                <img
                  src={require("../../Icons/QuickProperties/deleteForever.svg").default}
                  name={props.tabParentId || props?.id}
                  title={t("delete")}
                  onClick={(ev) => handleDelete(ev)}
                  className={classes.icons}
                  alt="Delete Icon"
                />
                {/* <img
                  src={require("../../Icons/QuickProperties/more.svg").default}
                  title={t("more")}
                  onClick={() => setMoreOpt(!moreOpt)}
                  className={classes.moreIcon}
                  alt="More Icon"
                /> */}
              </b>
            ) : props.elemType === "form" ? (
              <b>
                {/* {console.log("type4", props.elemType)} */}
                <img
                  src={require("../../Icons/QuickProperties/settings.svg").default}
                  title={t("settings")}
                  onClick={handleSettings}
                  className={classes.icons}
                  alt="Setting Icon"
                />
                <img
                  src={require("../../Icons/QuickProperties/download.svg").default}
                  title={t("download")}
                  onClick={handleDownload}
                  className={classes.icons}
                  alt="Download Icon"
                />
                <img
                  src={require("../../Icons/QuickProperties/grid.svg").default}
                  title={t("grid")}
                  onClick={handleGrid}
                  className={classes.icons}
                  alt="Grid Icon"
                />
                <img
                  src={require("../../Icons/QuickProperties/deleteForever.svg").default}
                  name={props.tabParentId || props?.id}
                  title={t("delete")}
                  onClick={(ev) => handleDelete(ev)}
                  className={classes.icons}
                  alt="Delete Icon"
                />
                {props.elemType === "wizard_h" || props.elemType === "wizard_v" ? (
                  <img
                    src={require("../../Icons/QuickProperties/more.svg").default}
                    title={t("more")}
                    onClick={() => setMoreOpt(!moreOpt)}
                    className={classes.moreIcon}
                    alt="More Icon"
                  />
                ) : null}
              </b>
            ) : props.elemType === "CustomControl" ? (
              <b>
                <img
                  src={require("../../Icons/QuickProperties/move.svg").default}
                  title={t("move")}
                  draggable={true}
                  onDragStart={(e) => props.handleReorderStart(e, props.dragId, props.dragType)}
                  onDrop={(ev) => props.handleReorderDrop(ev, props.elemType)}
                  onClick={handleMove}
                  className={classes.icons + " moveCss"}
                  alt="Move Icon"
                />
                <img
                  src={require("../../Icons/QuickProperties/deleteForever.svg").default}
                  name={props.tabParentId || props?.id}
                  title={t("delete")}
                  onClick={(ev) => handleDelete(ev)}
                  className={classes.icons}
                  alt="Delete Icon"
                />
              </b>
            ) : props.elemType === "column" ? (
              <b>
                {/* {console.log("type4", props.elemType)} */}
                {openCanvasForSubform === "showDataAdditonSection" || props?.data?.isInsideListview ? <></> : <img
                  src={require("../../Icons/QuickProperties/move.svg").default}
                  title={t("move")}
                  draggable={true}
                  onDragStart={(e) => props.handleReorderStart(e, props.dragId, props.dragType)}
                  onDrop={(ev) => props.handleReorderDrop(ev, props.elemType)}
                  onClick={handleMove}
                  className={classes.icons + " moveCss"}
                  alt="Move Icon"
                />}
                {openCanvasForSubform === "showDataAdditonSection" || props?.data?.isInsideListview ? <></> :<img
                  src={require("../../Icons/QuickProperties/settings.svg").default}
                  title={t("settings")}
                  onClick={handleSettings}
                  className={classes.icons}
                  alt="Setting Icon"
                />}
                {openCanvasForSubform === "showDataAdditonSection" || props?.data?.isInsideListview ? <></> :
                Object.keys(copyElement?.current).length > 0 ?
                <img
                  src={require("../../Icons/QuickProperties/paste.svg").default}
                  name={props.tabParentId || props?.id}
                  title={t("paste")}
                  onClick={(ev) => handlePaste(ev)}
                  className={classes.icons}
                  alt="Paste Icon"
                />
              :
              <></>}
                {openCanvasForSubform === "showDataAdditonSection" || props?.data?.isInsideListview ? <></> :
                <img
                  src={require("../../Icons/QuickProperties/deleteForever.svg").default}
                  name={props.tabParentId || props?.id}
                  title={t("delete")}
                  onClick={(ev) => handleDelete(ev)}
                  className={classes.icons}
                  alt="Delete Icon"
                  control_id={props?.id}
                />}
                {openCanvasForSubform === "showDataAdditonSection" || props?.data?.isInsideListview ? <></> : 
                <Upload
                  title={t("Import Control")}
                  onClick={(ev) =>{handleSelected(ev); onButtonClickColumn(ev)}}
                  className={classes.icons}
                  alt="Import Control Icon"
                  control_id={props?.id}
                  color="#fff"
                />}
                
              </b>
            ) : props.elemType === "row" ? (
              <b>
                {openCanvasForSubform === "showDataAdditonSection" || props?.data?.isInsideListview ? <></> : <img
                  src={require("../../Icons/QuickProperties/deleteForever.svg").default}
                  name={props.tabParentId || props?.id}
                  title={t("delete")}
                  onClick={(ev) => handleDelete(ev)}
                  className={classes.icons}
                  alt="Delete Icon"
                />}
                
              </b>
            ) : props.elemType === "LoginHeader" ? (
              <b>
                <img
                  src={require("../../Icons/QuickProperties/settings.svg").default}
                  title={t("settings")}
                  onClick={handleSettings}
                  className={classes.icons}
                  alt="Setting Icon"
                />
              </b>
            ) : props.elemType === "textbox" ||
              props.elemType === "textarea" ||
              props.elemType === "combo" ||
              props.elemType === "checkbox" ||
              props.elemType === "listbox" ||
              props.elemType === "datepick" ||
              props.elemType === "radio" ||
              props.elemType === "picklist" ||
              props.elemType === "toggle" ||
              props.elemType === "label" ||
              props.elemType === "paragraph" ||
              props.elemType === "link" ||
              props.elemType === "slider" ||
              props.elemType === "richtexteditor" ||
              props.elemType === "image" ||
              props.elemType === "button" ||
              props.elemType === "captcha" ? (
              <b>
                {/* {openCanvasForSubform === "showDataAdditonSection" || props?.data?.isInsideListview ? (
                  <></>
                ) : ( */}
                  <img
                    src={require("../../Icons/QuickProperties/move.svg").default}
                    title={t("move")}
                    draggable={true}
                    onDragStart={(e) => props.handleReorderStart(e, props.dragId, props.dragType, props.data)}
                    onDrop={(ev) => props.handleReorderDrop(ev, props.elemType)}
                    onClick={handleMove}
                    className={classes.icons + " moveCss"}
                    alt="Move Icon"
                  />
                {/* )} */}

                <img
                  src={require("../../Icons/QuickProperties/settings.svg").default}
                  title={t("settings")}
                  onClick={handleSettings}
                  className={classes.icons}
                  alt="Setting Icon"
                />
                {copying ? (
                  <>
                    {" "}
                    {openCanvasForSubform === "showDataAdditonSection" || props?.data?.isInsideListview ? (
                      <></>
                    ) : (
                      <img
                        src={require("../../Icons/QuickProperties/copy.svg").default}
                        title={t("copy")}
                        onClick={handleCopy}
                        className={copyClass}
                        alt="Copy Icon"
                      />
                    )}
                  </>
                ) : (
                  <>
                    {openCanvasForSubform === "showDataAdditonSection" || props?.data?.isInsideListview ? (
                      <></>
                    ) : (
                      <img
                        src={require("../../Icons/QuickProperties/copy.svg").default}
                        title={t("copy")}
                        onClick={handleCopy}
                        className={classes.icons}
                        alt="Copy Icon"
                      />
                    )}
                  </>
                )}
                {openCanvasForSubform === "showDataAdditonSection" || props?.data?.isInsideListview ? (
                  <></>
                ) : (
                  <img
                    src={require("../../Icons/QuickProperties/deleteForever.svg").default}
                    name={props.tabParentId || props?.id}
                    title={t("delete")}
                    onClick={(ev) => handleDelete(ev)}
                    className={classes.icons}
                    alt="Delete Icon"
                  />
                )}

                {/* <img
                src={require("../../Icons/QuickProperties/more.svg").default}
                title="more"
                onClick={() => setMoreOpt(!moreOpt)}
                className={classes.moreIcon}
              /> */}
              </b>
            ) : props.elemType === "report" ? (
              <b>
                <img
                  src={require("../../Icons/QuickProperties/move.svg").default}
                  title={t("move")}
                  draggable={true}
                  onDragStart={(e) => props.handleReorderStart(e, props.dragId, props.dragType)}
                  onDrop={(ev) => props.handleReorderDrop(ev, props.elemType)}
                  onClick={handleMove}
                  className={classes.icons + " moveCss"}
                  alt="Move Icon"
                />
                <img
                  src={require("../../Icons/QuickProperties/settings.svg").default}
                  title={t("settings")}
                  onClick={handleSettings}
                  className={classes.icons}
                  alt="Setting Icon"
                />
                {copying ? (
                  <img
                    src={require("../../Icons/QuickProperties/copy.svg").default}
                    title={t("copy")}
                    onClick={handleCopy}
                    className={copyClass}
                    alt="Copy Icon"
                  />
                ) : (
                  <img
                    src={require("../../Icons/QuickProperties/copy.svg").default}
                    title={t("copy")}
                    onClick={handleCopy}
                    className={classes.icons}
                    alt="Copy Icon"
                  />
                )}
                <img
                  src={require("../../Icons/QuickProperties/download.svg").default}
                  title={t("download")}
                  onClick={() => downloadJson(props.data, props?.id)}
                  className={classes.icons}
                  alt="Download Icon"
                />
                <img
                  src={require("../../Icons/QuickProperties/deleteForever.svg").default}
                  name={props.tabParentId || props?.id}
                  title={t("delete")}
                  onClick={(ev) => handleDelete(ev)}
                  className={classes.icons}
                  alt="Delete Icon"
                />
                {/* <img
              src={require("../../Icons/QuickProperties/more.svg").default}
              title="more"
              onClick={() => setMoreOpt(!moreOpt)}
              className={classes.moreIcon}
            /> */}
              </b>
            ) : props.elemType === "Menu" ? (
              <b>
                <img
                  src={require("../../Icons/QuickProperties/move.svg").default}
                  title={t("move")}
                  draggable={true}
                  onDragStart={(e) => props.handleReorderStart(e, props.dragId, props.dragType)}
                  onDrop={(ev) => props.handleReorderDrop(ev, props.elemType)}
                  onClick={handleMove}
                  className={classes.icons + " moveCss"}
                  alt="Move Icon"
                />
                <img
                  src={require("../../Icons/QuickProperties/settings.svg").default}
                  title={t("settings")}
                  onClick={handleSettings}
                  className={classes.icons}
                  alt="Setting Icon"
                />
                {/* {copying ? (
                <img
                  src={require("../../Icons/QuickProperties/copy.svg").default}
                  title="copy"
                  // onClick={handleCopy}
                  className={copyClass}
                />
              ) : (
                <img
                  src={require("../../Icons/QuickProperties/copy.svg").default}
                  title="copy"
                  onClick={handleCopy}
                  className={classes.icons}
                />
              )} */}
                <img
                  src={require("../../Icons/QuickProperties/deleteForever.svg").default}
                  name={props.tabParentId || props?.id}
                  title={t("delete")}
                  onClick={(ev) => handleDelete(ev)}
                  className={classes.icons}
                  alt="Delete Icon"
                />
                {/* <img
                src={require("../../Icons/QuickProperties/more.svg").default}
                title="more"
                onClick={() => setMoreOpt(!moreOpt)}
                className={classes.moreIcon}
              /> */}
                {/* <img src={require("../../Icons/QuickProperties/grid.svg").default} title="grid" onClick = {handleGrid} className = {classes.icons}/>
                        <img src={require("../../Icons/QuickProperties/download.svg").default} title="download" onClick = {handleDownload} className = {classes.icons}/> */}
              </b>
            ) : props.elemType === "imagecarousel" ? (
              <b>
                <img
                  src={require("../../Icons/QuickProperties/move.svg").default}
                  title={t("move")}
                  draggable={true}
                  onDragStart={(e) => props.handleReorderStart(e, props.dragId, props.dragType)}
                  onDrop={(ev) => props.handleReorderDrop(ev, props.elemType)}
                  onClick={handleMove}
                  className={classes.icons + " moveCss"}
                  alt="Move Icon"
                />
                <img
                  src={require("../../Icons/QuickProperties/settings.svg").default}
                  title={t("settings")}
                  onClick={handleSettings}
                  className={classes.icons}
                  alt="Setting Icon"
                />
                {copying ? (
                  <img
                    src={require("../../Icons/QuickProperties/copy.svg").default}
                    title={t("copy")}
                    onClick={handleCopy}
                    className={copyClass}
                    alt="Copy Icon"
                  />
                ) : (
                  <img
                    src={require("../../Icons/QuickProperties/copy.svg").default}
                    title={t("copy")}
                    onClick={handleCopy}
                    className={classes.icons}
                    alt="Copy Icon"
                  />
                )}
                <img
                  src={require("../../Icons/QuickProperties/deleteForever.svg").default}
                  name={props.tabParentId || props?.id}
                  title={t("delete")}
                  onClick={(ev) => handleDelete(ev)}
                  className={classes.icons}
                  alt="Delete Icon"
                />
                {/* {props.elemType !== "advancelistView" &&
                  props.elemType !== "wizard_h" &&
                  props.elemType !== "wizard_v" && (
                    <img
                      src={
                        require("../../Icons/QuickProperties/more.svg").default
                      }
                      title={t("more")}
                      onClick={() => setMoreOpt(!moreOpt)}
                      className={classes.moreIcon}
                      alt="More Icon"
                    />
                  )} */}
                {/* <img src={require("../../Icons/QuickProperties/grid.svg").default} title="grid" onClick = {handleGrid} className = {classes.icons}/>
                        <img src={require("../../Icons/QuickProperties/download.svg").default} title="download" onClick = {handleDownload} className = {classes.icons}/> */}
              </b>
            ) : (
              <b>
                <img
                  src={require("../../Icons/QuickProperties/move.svg").default}
                  title={t("move")}
                  draggable={true}
                  onDragStart={(e) => props.handleReorderStart(e, props.dragId, props.dragType)}
                  onDrop={(ev) => props.handleReorderDrop(ev, props.elemType)}
                  onClick={handleMove}
                  className={classes.icons + " moveCss"}
                  alt="Move Icon"
                />
                <img
                  src={require("../../Icons/QuickProperties/settings.svg").default}
                  title={t("settings")}
                  onClick={handleSettings}
                  className={classes.icons}
                  alt="Setting Icon"
                />
                {copying ? (
                  <img
                    src={require("../../Icons/QuickProperties/copy.svg").default}
                    title={t("copy")}
                    onClick={handleCopy}
                    className={copyClass}
                    alt="Copy Icon"
                  />
                ) : (
                  <img
                    src={require("../../Icons/QuickProperties/copy.svg").default}
                    title={t("copy")}
                    onClick={handleCopy}
                    className={classes.icons}
                    alt="Copy Icon"
                  />
                )}
                <img
                  src={require("../../Icons/QuickProperties/deleteForever.svg").default}
                  name={props.tabParentId || props?.id}
                  title={t("delete")}
                  onClick={(ev) => handleDelete(ev)}
                  className={classes.icons}
                  alt="Delete Icon"
                />
                {props.elemType !== "advancelistView" &&
                  props.elemType !== "wizard_h" &&
                  props.elemType !== "wizard_v" && (
                    <img
                      src={require("../../Icons/QuickProperties/more.svg").default}
                      title={t("more")}
                      onClick={() => setMoreOpt(!moreOpt)}
                      className={classes.moreIcon}
                      alt="More Icon"
                    />
                  )}
                {/* <img src={require("../../Icons/QuickProperties/grid.svg").default} title="grid" onClick = {handleGrid} className = {classes.icons}/>
                        <img src={require("../../Icons/QuickProperties/download.svg").default} title="download" onClick = {handleDownload} className = {classes.icons}/> */}
              </b>
            )}
            <div control_id={props?.id} onClick={(e) => {handleSelected(e, props?.id, "n"); e.stopPropagation();}} className={classes.main} onMouseLeave={() => setMoreOpt(false)}>
              {moreOpt &&
                (props.elemType === "section" || props.elemType === "frame" ? (
                  // (props.elemType === "section" || props.elemType === "frame" || props.elemType === "datepick" || props.elemType === "table" || props.elemType === "listview" || props.elemType === "advlistview" || props.elemType === "subform" || props.elemType === "report" || props.elemType === "doclist" || props.elemType === "tile" || props.elemType === "imagecarousel"? (
                  <span
                    className={classes.optionsPopUp}
                    control_id={props?.id}
                    onClick={(e) => {handleSelected(e, props?.id, "n"); e.stopPropagation();}}
                    style={translationStyles1 ? { right: "110px", left: "unset", width: "141px" } : null}
                  >
                    <span control_id={props?.id} onClick={(e) => {handleSelected(e,props?.id,"n"); handleSaveTemplate(e)}} style={{color:"#000000",padding:"4px 0",paddingTop:"4px"}}> {t("Save as Template")} </span>
                    <span control_id={props?.id} onClick={(e) => {handleSelected(e, props?.id, "n");testinghandler(e);}} style={{ color:"#000000",padding:"4px 0"}}>
                      <span control_id={props?.id} onClick={(e) => {handleSelected(e, props?.id, "n"); onButtonClick1(e);}} className={classes.uploadJson}>
                        {" "}
                        {t("Import Controls")}{" "}
                      </span>
                    </span>
                    {/* <span > Upload Section </span> */}
                    <span control_id={props?.id} onClick={(e) => { handleSelected(e,props?.id,"n"); testinghandler(e);}} style={{ color:"#000000",padding:"4px 0"}}>
                      <span
                        onClick={(e) => {handleSelected(e,props?.id,"n"); onButtonClick(e,"section");}}
                        // className="uploadClass"
                        className={classes.uploadJson}
                        control_id={props?.id}
                        // style={{marginLeft:"-1px"}}
                        style={{color:"#000000",padding:"4x 0",paddingBottom:"4px"}}
                      >
                        {t("Upload Section")}
                      </span>
                    </span>
                  </span>
                ) : props.elemType === "subform" ? (
                  <span
                    className={classes.optionsPopUp}
                    style={translationStyles1 ? { right: "110px", left: "unset", width: "141px" } : null}
                  >
                    <span> {t("Upload Subform")} </span>
                    <span> {t("Import Controls")} </span>
                  </span>
                ) : props.elemType === "sheet" ? (
                  <span
                    className={classes.optionsPopUp}
                    style={translationStyles1 ? { right: "110px", left: "unset", width: "141px" } : null}
                  >
                    <span onClick={(e) => uploadJson(e, "sheet")}> {t("Upload TabSheet")} </span>
                    <span> {t("Import Controls")} </span>
                  </span>
                ) : props.elemType === "step" ? (
                  <span
                    className={classes.optionsPopUp}
                    style={translationStyles1 ? { right: "110px", left: "unset", width: "141px" } : null}
                  >
                    <span> {t("Upload Step")} </span>
                    <span> {t("Import Controls")} </span>
                  </span>
                ) : //   : props.elemType === "iframe" ? (
                //   <span className={classes.optionsPopUp}>
                //     <span > Upload Iframe </span>
                //   </span>
                // )
                props.elemType === "tab" ? (
                  <span
                    control_id={props?.id}
                    className={classes.optionsPopUp}
                    style={translationStyles1 ? { right: "110px", left: "unset", width: "141px" } : null}
                  >
                    <span control_id={props?.id} onClick={(e) => {handleSelected(e,props?.id,"n"); testinghandler(e);}} style={{ marginTop: "-3px" }}>
                      <span control_id={props?.id} onClick={(e) => {handleSelected(e,props?.id,"n"); onButtonClick2(e);}} className={classes.uploadJson}>
                        {t("Upload Tabs")}
                      </span>
                    </span>
                  </span>
                ) : props.elemType === "sidenavigation" ? (
                  <span
                    className={classes.optionsPopUp}
                    style={translationStyles1 ? { right: "110px", left: "unset", width: "141px" } : null}
                  >
                    <span> {t("Upload Tabs")} </span>
                  </span>
                ) : props.elemType === "wizard" ? (
                  <span
                    className={classes.optionsPopUp}
                    style={translationStyles1 ? { right: "110px", left: "unset", width: "141px" } : null}
                  >
                    <span onClick={(e) => uploadJson(e, "tab")}> {t("Upload Wizards")} </span>
                  </span>
                ) : props.elemType === "table" ? (
                  <span
                    className={classes.optionsPopUp}
                    control_id={props?.id}
                    style={translationStyles1 ? { right: "110px", left: "unset", width: "141px" } : null}
                  >
                    <span onClick={(e) => {handleSelected(e,props?.id,"n"); onButtonClickTableUpload(e,"table")}}> {t("Upload Table")} </span>
                  </span>
                ) : props.elemType === "listview" ? (
                  <span
                    className={classes.optionsPopUp}
                    control_id={props?.id}
                    style={translationStyles1 ? { right: "110px", left: "unset", width: "141px" } : null}
                  >
                    <span onClick={(e) => { handleSelected(e,props?.id,"n"); onButtonClickTableUpload(e,"listview")}}> {t("Upload ListView")} </span>
                  </span>
                ) : props.elemType === "report" ? (
                  <span
                    className={classes.optionsPopUp}
                    style={translationStyles1 ? { right: "110px", left: "unset", width: "141px" } : null}
                  >
                    <span> {t("Upload Reports")} </span>
                  </span>
                // ) : props.elemType === "doclist" ? (
                //   <span
                //     className={classes.optionsPopUp}
                //     style={translationStyles1 ? { right: "110px", left: "unset", width: "141px" } : null}
                //   >
                //     <span> {t("Upload DocList")} </span>
                //   </span>
                ) : props.elemType === "tile" ? (                  
                  <span
                  className={classes.optionsPopUpTile}
                  control_id={props?.id}
                  style={translationStyles1 ? { right: "48px", left: "unset" } : {left:"48px"}}
                >
                  <span onClick={(e) => { handleSelected(e,props?.id,"n"); testinghandler(e);}} control_id={props?.id} style={{ marginTop: "-3px" }} title={t("Upload Tiles")}>
                    <span onClick={(e) => { handleSelected(e,props?.id,"n"); onTileClick(e);}} control_id={props?.id} className={classes.uploadJson}>
                      {t("Upload Tiles")}
                    </span>                    
                  </span>
                </span>
                ) : props.elemType === "wizard_h" ? (
                  <span
                    className={classes.optionsPopUp}
                    control_id={props?.id}
                    style={translationStyles1 ? { right: "110px", left: "unset", width: "141px" } : null}
                  >
                    <span control_id={props?.id} onClick={(e) => {handleSelected(e,props?.id,"n"); testinghandler();}} style={{ marginTop: "-3px" }}>
                      <span control_id={props?.id} onClick={(e) => {handleSelected(e,props?.id,"n") ;onButtonClick(e,"wizard_h");}} className={classes.uploadJson}>
                        {t("Upload Wizard")}
                      </span>
                      <input
                        aria-label={"Upload JSON5"}
                        type="file"
                        id="file"
                        ref={inputFile}
                        style={{ display: "none" }}
                        onChange={(e) => uploadJson(e, "wizard_h")}
                        accept="application/JSON"
                      />
                    </span>
                  </span>
                ) : props.elemType === "wizard_v" ? (
                  <span
                    className={classes.optionsPopUp}
                    control_id={props?.id}
                    style={translationStyles1 ? { right: "110px", left: "unset", width: "141px" } : null}
                  >
                    <span control_id={props?.id} onClick={(e) => { handleSelected(e,props?.id,"n");testinghandler()}} style={{ marginTop: "-3px" }}>
                      <span control_id={props?.id} onClick={(e) => {handleSelected(e,props?.id,"n"); onButtonClick(e,"wizard_v")}} className={classes.uploadJson}>
                        {t("Upload Wizard")}
                      </span>
                    </span>
                  </span>
                ) : (
                  <span
                    className={classes.optionsPopUp}
                    style={translationStyles1 ? { right: "110px", left: "unset", width: "141px" } : null}
                  >
                    {/* <span > Download </span>
                        <span > Delete </span> */}
                  </span>
                ))}
            </div>
            {/* <span name={tabParentId || id} onClick={(ev)=> handleDelete(ev)} >
                    <Delete/>
                </span> */}
            {showGridSelector && showGridSelector === true ? (
              <Dialog
                // onClose={handleCancel}
                classes={{ paper: classes.dialog }}
                open={showGridSelector}
                BackdropProps={{
                  classes: {
                    root: classes.root
                  }
                }}
                PaperProps={{
                  classes: {
                    root: classes.paper
                  }
                }}
                onClose={() => {
                  handleCancel(); 
                  setShowGridSelector(false); 
                }}
              >
                <DialogTitle classes={{ root: classes.dialogTitle }}>
                  <span className={classes.dialogHead}>{t("Quick Properties")}</span>
                  <span className={classes.controlHead}>- {props && props.data.elem_type}</span>
                </DialogTitle>
                {/* <Divider className={classes.divider}/> */}

                <DialogContent classes={{ root: classes.dialogContent }}>
                  {/* {Items.map((item, index) => {
                return item;
              })} */}
                  <ActiveIcon
                    layout="3"
                    defaultValue="1"
                    spacing="0"
                    labelPosition="in"
                    labelStyle={{ fontSize: "11px" }}
                    activeStyle={{
                      padding: "6px",
                      margin: "0",
                      background: "#fff",
                      border: "1px solid #0072c6",
                      width: "89px",
                      color: "#0072C6"
                    }}
                    inActiveStyle={{
                      padding: "6px",
                      margin: "0",
                      background: "#fff",
                      border: "1px solid #c6c9cf",
                      width: "89px"
                    }}
                    passedValue={String(layout)}
                    //   property={value.field}
                    handleStyleType={setColumnLayout}
                  >
               <TabColumn1 value="1" label="1 COLUMN" style={{ paddingRight: "9px" }} />
                <TabColumn2 value="2" label="2 COLUMNS"style={{paddingRight:"9px"}}  />
                <TabColumn3 value="3" label="3 COLUMNS"style={{paddingRight:"9px"}}  />
                <TabColumn4 value="4" label="4 COLUMNS"style={{paddingRight:"9px"}}  />
                <TabColumn5 value="6" label="6 COLUMNS"style={{paddingRight:"9px"}}  />
                <TabColumn6 value="12" label="12 COLUMNS"style={{paddingRight:"9px"}}  />
                  </ActiveIcon>
                </DialogContent>

                <DialogActions classes={{ root: classes.dialogActions }}>
                  {/* <Button classes={{root:classes.btn1,label:classes.btn1label}} >{t("Cancel")}</Button>
                            <Button classes={{root:classes.btn2,label:classes.btn2label}} color="primary">{t("Save & Exit")}</Button>
                            <Button classes={{root:classes.btn3,label:classes.btn3label}}  color="primary">{t("Save & Exit")}</Button>     */}
                  <span className={classes.btn1} onClick={handleCancel}>
                    <img
                      src={require("../../Icons/QuickProperties/cancel.svg").default}
                      title={t("Cancel")}
                      className={classes.icons}
                      style={{marginTop: "0px",marginBottom: "0px"}}
                      alt="Cancel Icon"
                    />
                    &nbsp; {t("Cancel")}
                  </span>
                  <span className={classes.btn2} onClick={handleView}>
                    <img
                      src={require("../../Icons/QuickProperties/viewall.svg").default}
                      title={t("View all")}
                      className={classes.icons}
                      style={{marginTop: "0px",marginBottom: "0px"}}
                      alt="View All Icon"
                    />
                    &nbsp; {t("View all")}
                  </span>
                  <span className={classes.btn3} onClick={handleDone}>
                    <img
                      src={require("../../Icons/QuickProperties/done.svg").default}
                      title={t("Done")}
                      className={classes.icons}
                      style={{marginTop: "0px",marginBottom: "0px"}}
                      alt="Done Icon"
                    />
                    &nbsp; {t("Done")}
                  </span>
                </DialogActions>
              </Dialog>
            ) : null}
          </div>
          {showImportSectionPopUp ? (
            <ImportSection
              containerId={props.containerId}
              fileName={fileName}
              setShowImportSectionPopUp={setShowImportSectionPopUp}
              uploadedJson={uploadedJson}
              id={props.id}
              data={props.data}
              isTableUpload={isTableUpload}
              setIsTableUpload={setIsTableUpload}
              currentColumn={props.dragId}
            />
          ) : null}

          {savePageTemplate_popup === true && (
            <SaveTemplate
              sectionBuffer={props?.data}
              containerId={props.containerId}
              screenShot={screenShot}
              templateType={"app"}
              setAlertData1={setAlertData}
              setSavePageTemplate_popup={setSavePageTemplate_popup}
            />
          )}

          {alertData.open === true && (
            <CustomizedAlert
              alertData={alertData}
              // handleFunction={(Id) => callForDelete(Id)}
            />
          )}
        </>
      )}
    </>
  );
}

export default React.memo(ElemDeleteControl);